<template>
  <div>
    <h2>Offers</h2>
    <OfferList :offers="formattedOffers" />
  </div>
</template>

<script>
import OfferList from "@/views/offers/components/OfferList";
import { map } from "lodash";

export default {
  name: "WorkerOffers",
  components: {
    OfferList
  },
  props: {
    userData: {
      type: Object,
      required: true
    }
  },
  computed: {
    formattedOffers() {
      return map(this.userData.offers, offer => {
        const { booking } = offer.application;
        const { title } = booking || { title };
        return { ...offer, title };
      });
    }
  }
};
</script>
